import pageBackground from "../images/characters-black.png";
import gamesBackground from "../images/games.png";

const images = {
  pageBackground,
  gamesBackground,
};

export default images;
